import { UserTabs } from './user-tabs.model';
import { UserTypes } from '../user-types.enum';

export const UserTabsHierarchyBased = {
  dashpivot: {
    company: {
      tabs: [
        {
          titleCode: 'contributor',
          routerLink: `${UserTypes.Dashpivot}/contributors`,
        },
        {
          titleCode: 'visitor',
          routerLink: `${UserTypes.Dashpivot}/visitors`,
        },
      ] as UserTabs[],
    },
    project: {
      tabs: [
        {
          titleCode: 'contributor',
          routerLink: `${UserTypes.Dashpivot}/contributors`,
        },
        {
          titleCode: 'visitor',
          routerLink: `${UserTypes.Dashpivot}/visitors`,
        },
      ] as UserTabs[],
    },
    team: {
      tabs: [
        {
          titleCode: 'contributor',
          routerLink: `${UserTypes.Dashpivot}/contributors`,
        },
        {
          titleCode: 'visitor',
          routerLink: `${UserTypes.Dashpivot}/visitors`,
        },
      ] as UserTabs[],
    },
  },
  sitemate: {
    tabs: [
      {
        titleCode: 'freeUsers',
        routerLink: `${UserTypes.Sitemate}/id-cards`,
      },
      {
        titleCode: 'paidUsers',
        routerLink: `${UserTypes.Sitemate}/forms`,
      },
    ] as UserTabs[],
  },
};
